<template>
  <div>
    <v-container fluid px-5 pb-5>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm6 xs12>
              <v-menu
                ref="menuTime"
                v-model="menuTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="time"
                    :label="$t('time')"
                    disabled
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="time" full-width @click:minute="$refs.menuTime.save(time)"></v-time-picker>
              </v-menu>
            </v-flex>

            <v-flex sm6 xs12>
              <v-menu
                ref="menu"
                v-model="menuDate"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormatted"
                    :label="$t('date')"
                    disabled
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  :first-day-of-week="1"
                  locale="es-ES"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="menuDate = false">{{$t('cancel')}}</v-btn>
                  <v-btn color="success" @click="$refs.menu.save(date)">{{$t('accept')}}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md12 sm12 xs12>
              <v-autocomplete
                v-model="judges"
                :items="judgesList"
                chips
                disabled
                :label="$t('judges')"
                item-text="text"
                item-value="value"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip color="white" :selected="data.selected" class="chip--select-multi">
                    <v-avatar>
                      <img :src="data.item.photo">
                    </v-avatar>
                    {{ data.item.text }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-avatar>
                    <img :src="data.item.photo">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex md12 sm12 xs12>
              <v-autocomplete
                v-model="location"
                :items="listLocations"
                chips
                disabled
                :label="$t('location')"
                item-text="text"
                item-value="value"
              >
                <template v-slot:selection="data">{{ data.item.text }}</template>
                <template v-slot:item="data">
                  <v-list-tile-avatar>
                    <img :src="data.item.photo">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <hr>
            <template v-if="matchType==='user'">
              <v-flex md12 sm12 xs12>
                <p>Usuario</p>
              </v-flex>
              <v-flex md12 sm6 xs12>
                <v-autocomplete
                  v-model="user"
                  :items="userList"
                  chips
                  disabled
                  :label="$tc('user')"
                  item-text="text"
                  item-value="value"
                >
                  <template v-slot:selection="data">
                    <v-chip color="white" :selected="data.selected" class="chip--select-multi">
                      <v-avatar>
                        <img :src="data.item.photo">
                      </v-avatar>
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-tile-avatar>
                      <img :src="data.item.photo">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <template v-if="edit">
              <v-flex md12 sm12 xs12>
                <p>{{$t('result')}}</p>
              </v-flex>
              <v-flex md6 sm6 xs12>
                <v-text-field
                  :label="$t('result')"
                  v-model="finalScoreUser"
                  :disabled="!edit"
                  type="number"
                ></v-text-field>
              </v-flex>
              </template>
            </template>
            <template v-else>
              <v-flex md12 sm12 xs12>
                <p>{{$tc('team',2)}}</p>
                <v-autocomplete
                  v-model="teams"
                  :items="teamList"
                  chips
                  :label="$tc('team',2)"
                  item-text="text"
                  item-value="value"
                  disabled
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip
                      color="white"
                      :selected="data.selected"
                      class="chip--select-multi"
                    >{{ data.item.text }}</v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.entity"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex md5 sm5 xs12>
                <v-autocomplete
                  v-model="homeTeamId"
                  :items="teamList"
                  chips
                  :label="$t('homeTeam')"
                  :disabled="!edit"
                >
                  <template v-slot:selection="data">{{ data.item.text }}</template>
                  <template v-slot:item="data">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.entity"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex md5 sm5 xs12>
                <v-autocomplete
                  v-model="visitorTeamId"
                  :items="teamList"
                  chips
                  :label="$t('visitorTeam')"
                  :disabled="!edit"
                >
                  <template v-slot:selection="data">{{ data.item.text }}</template>
                  <template v-slot:item="data">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.entity"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex v-if="edit" md2 sm2 xs12 align-self-center>
                <v-btn v-if="matchType!='user'" @click="changeTeams()" color="primary" small>
                  <span v-if="loading">
                    <v-progress-circular :size="20" :width="3" color="#6273B7" indeterminate></v-progress-circular>
                  </span>
                  <v-icon v-else>compare_arrows</v-icon>
                </v-btn>
              </v-flex>
              <template v-if="edit">
              <hr>
              <v-flex md12 sm12 xs12>
                <p>{{$t('result')}}</p>
              </v-flex>
                <v-flex md5 sm5 xs12>
                  <v-text-field
                    :label="$t('homeTeamResult')"
                    v-model="finalScoreHomeTeam"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex md5 sm5 xs12>
                  <v-text-field
                    :label="$t('visitorTeamResult')"
                    v-model="finalScoreVisitTeam"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </template>
            </template>
            <v-flex v-if="edit" md2 sm2 xs12 align-self-center>
              <v-btn @click="clearResults()" color="warning" small>{{$t('reset')}}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="edit ">
        <v-spacer></v-spacer>
        <v-btn @click="updateMatch()" color="secondary" small>
          <span v-if="loading2">
            <v-progress-circular :size="20" :width="3" color="#6273B7" indeterminate></v-progress-circular>
          </span>
          <span v-else>{{$t('update')}}</span>
        </v-btn>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  formatDate,
  formatDatePicker
} from '../../../helpers/dateHelper'
export default {
  name: 'tabInformation',
  props: {
    matchType: {
      type: String,
      required: true,
      default: ''
    },
    edit: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      loading2: false,
      menuDate: false,
      menuTime: false,

      type: '',
      active: true,
      date: null,
      time: null,
      actId: '',
      judges: [],
      location: '',
      homeTeamId: '',
      visitorTeamId: '',

      finalScoreHomeTeam: 0,
      finalScoreVisitTeam: 0,
      finalScoreUser: 0,

      teams: [],
      user: ''
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    homeTeamId: function (newValue, oldValue) {
      if (
        newValue === this.visitorTeamId &&
        this.teams &&
        this.teams.includes(oldValue)
      ) { this.visitorTeamId = oldValue }
    },
    visitorTeamId: function (newValue, oldValue) {
      if (
        newValue === this.homeTeamId &&
        this.teams &&
        this.teams.includes(oldValue)
      ) { this.homeTeamId = oldValue }
    },
    match: function (val) {
      this.init()
    }
  },
  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      match: state => state.matches.matchSelected,
      matchId: state => state.matches.idSelected
    }),
    dateFormatted () {
      return formatDate(this.date)
    },
    judgesList () {
      if (!this.match || !this.match.judgesName) return []
      return this.match.judgesName.map(item => ({ value: item._id, text: item.name, photo: process.env.VUE_APP_IMAGE_URL + item.photo }))
    },
    userList () {
      if (!this.match || !this.match.user || !this.match.userName) return []
      return [{ value: this.match.user, text: this.match.userName.name, photo: process.env.VUE_APP_IMAGE_URL + this.match.userName.photo }]
    },
    teamList () {
      if (!this.match || !this.match.teams) return []
      let teamList = []
      if (this.match.homeTeamId) teamList.push({ value: this.match.homeTeamId, text: this.match.homeTeam })
      if (this.match.visitorTeamId) teamList.push({ value: this.match.visitorTeamId, text: this.match.visitorTeam })
      return teamList
    },
    listLocations () {
      if (!this.match || !this.match.location) return []
      return [{ value: this.match.location, text: this.match.locationName.name, photo: process.env.VUE_APP_IMAGE_URL + this.match.locationName.photo }]
    }

  },
  methods: {
    ...mapActions({
      setUpdate: 'matches/setUpdate'
    }),
    init () {
      this.resetForm()
      if (this.match) this.updateForm()
      else {
        const vm = this
        setTimeout(() => {
          vm.init()
        }, 500)
      }
    },
    updateMatch () {
      let match = {
        ...this.match,
        teams: this.teams,
        homeTeamId: this.homeTeamId,
        visitorTeamId: this.visitorTeamId,
        finalScoreHomeTeam: this.finalScoreHomeTeam,
        finalScoreVisitTeam: this.finalScoreVisitTeam,
        finalScoreUser: this.finalScoreUser
      }
      delete match.actId
      this.loading2 = true
      this.setUpdate(match).finally(() => {
        this.loading2 = false
      })
    },
    updateForm () {
      const match = this.match
      this.type = match.type
      this.date = formatDatePicker(match.date)
      this.time = match.time
      this.judges = match.judges
      this.location = match.location
      this.homeTeamId = match.homeTeamId
      this.visitorTeamId = match.visitorTeamId
      this.teams = match.teams
      this.user = match.user
      this.finalScoreHomeTeam = match.finalScoreHomeTeam
      this.finalScoreVisitTeam = match.finalScoreVisitTeam
      this.finalScoreUser = match.finalScoreUser
    },
    resetForm () {
      this.type = ''
      this.active = true
      this.date = null
      this.time = null
      this.actId = ''
      this.judges = []
      this.location = ''
      this.homeTeamId = ''
      this.visitorTeamId = ''
      this.finalScoreHomeTeam = 0
      this.finalScoreVisitTeam = 0
      this.finalScoreUser = 0
      this.teams = []
      this.user = ''
    },
    clearResults () {
      this.finalScoreHomeTeam = null
      this.finalScoreVisitTeam = null
      this.finalScoreUser = null
    },
    changeTeams () {
      let match = {
        ...this.match,
        homeTeamId: this.match.visitorTeamId,
        visitorTeamId: this.match.homeTeamId,
        finalScoreHomeTeam: this.finalScoreVisitTeam,
        finalScoreVisitTeam: this.finalScoreHomeTeam
      }
      delete match.actId
      this.loading = true
      this.setUpdate(match).finally(() => {
        this.loading = false
      })
    },
    removeTeam (item) {
      const index = this.teams.indexOf(item.value)
      if (index >= 0) this.teams.splice(index, 1)
    }
  }
}
</script>

<style scoped>
</style>
